import * as React from 'react'
import { RouterState, RouterAction, routerActions } from 'react-router-redux'
import { connect, Dispatch } from 'react-redux'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { StickyContainer, Sticky } from 'react-sticky'
import moment from 'moment'
import { ListItem } from 'material-ui/List'
import { FlatButton } from 'material-ui'
import Divider from '@material-ui/core/Divider'

import { StoreState } from '../reducers'
import { Api } from '../services/api/api'
import { EventType } from '../services/events/events'

import { AppBarContainer } from './CustomAppBar'
import { BaseContainer } from './BaseContainer'

import PageTitle from '../components/PageTitle'
import ErrorDialog from '../components/ErrorDialog'
import { StarRatings } from '../components/StarRating'
import { DialogBox } from '../components/DialogBox'
import { AcceptDialog } from '../components/AcceptDialog'
import Timer from '../components/Timer'

import { Bid, PublishedJobParams, ComplimentsNumber, Hauler, Slots } from '../types'
import { JobStatus } from '../types/enums/JobStatus'

import { Error as ErrorInfo } from '../types/Errors/Error'

import images from '../images'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

import '../styles/ViewBids.scss'
import 'react-perfect-scrollbar/dist/css/styles.css'

import { ROUTES } from '../constants/routes'
import { setJobStatus, removeJobDetails, setPublishedJobParams, setAmount, saveComplimentsNumber, setProviderId, setFutureDateFrom, setFutureDateTo, setBids } from '../actions/setJobDetails'
import { Actions as JobActions, ActionType as JobActionType } from '../actions/job'
import { ActionType as ErrorInfoActionType, Actions as ErrorActions } from '../actions/errorInfo'

import Mapper from '../utils/Mapper'
import { Hash } from '../utils/securityUtils'
import { getFormatedPrice } from '../utils/PricingUtils'
import { interval } from '../constants/interval'
import {prepareError} from '../utils/ErrorUtils';

interface ViewBidsProps {
  routing: RouterState
  jobId: string
  jobCategoryName: string
  publishedJobParams: PublishedJobParams
  jobCategories: any,
  selectedJobCategory: string
  complimentsNumber: ComplimentsNumber[]

  routePush: (path: String) => RouterAction
  onErrorEvent: (errorInfo: ErrorInfo) => ErrorInfoActionType
  onSetJobStatus: (status: string) => void
  setProviderId: (providerId: string) => void
  onRemoveJobDetails: () => void
  onPublishedJobParams: (publishedJobParams: PublishedJobParams) => void
  onSetAmount: (amount: number) => void
  removeJob: () => JobActionType
  saveComplimentsNumber: (complimentsNumber: ComplimentsNumber[]) => void
  onSetFutureDateFrom: (futureDateFrom: number) => void
  onSetFutureDateTo: (futureDateTo: number) => void,
  onSetBids: (bids: Bid[]) => void
}

interface ViewBidsStates {
  jobId: string,
  bidsArray: Array<Bid>,
  selectedBid: number,
  hours: number,
  minutes: number,
  seconds: number,
  interval?: any,
  createDate: number
  isBidAccepted: boolean
  checkBidsInterval?: any
  haulerId: string
  isDialogOpen: boolean
  isJobAccepted: boolean
  timeExpired: boolean
  status: string
  isAcceptDialogOpen: boolean
  isErrorDialogOpen: boolean
  errorTitle: string
  errorMessage: string
  isUnderReview: boolean
  complimentsNumber: ComplimentsNumber[]
  timerValue: string | null
  isBiddingExpiring: boolean
}

// JobId for tests: 'bf46aa47-fd37-4a75-8c5b-e30339c0719c'

export class ViewBids extends React.Component<ViewBidsProps, ViewBidsStates> {
    _isMounted:boolean;

  constructor(props: any) {
    super(props)
    this.state = {
      jobId: this.props.jobId,
      bidsArray: [],
      selectedBid: -1,
      hours: this.props.publishedJobParams.hours,
      minutes: this.props.publishedJobParams.minutes,
      seconds: this.props.publishedJobParams.seconds,
      createDate: 0,
      isBidAccepted: false,
      isJobAccepted: false,
      haulerId: '',
      isDialogOpen: false,
      timeExpired: false,
      status: '',
      isAcceptDialogOpen: false,
      isErrorDialogOpen: false,
      errorTitle: '',
      errorMessage: '',
      isUnderReview: false,
      complimentsNumber: this.props.complimentsNumber,
      timerValue: null,
      isBiddingExpiring: false
    }
  }
  componentDidMount() {
    this._isMounted = true;
    if (this.props.jobCategoryName !== '') {
      this.checkBids()
      this.checkJobStatus()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.minutes !== nextProps.publishedJobParams.minutes) {
      this.setState({
        minutes: this.props.publishedJobParams.minutes,
        seconds: this.props.publishedJobParams.seconds
      })
    }
  }

  loadAndSaveBids = () => {
    this.checkJobStatus()
    Api.getBidsForJob(this.props.jobId)
      .then(bids => {
          if(!this._isMounted)
              return;
        const bidsLengthChanged = this.state.bidsArray && this.state.bidsArray.length !== bids.length
        this.setState({
          bidsArray: bids
        })
        if (bids.length !== 0) {
          this.props.onSetBids(bids)
          this.setComplimentsNumber(this.props.complimentsNumber, bids)
            if (bids.length === 1) {
              this.setState({
                selectedBid: 0,
                haulerId: this.state.bidsArray[0].haulerId
              })
            }
          if (bidsLengthChanged) {
            this.setState({
              selectedBid: -1
            })
          }
        } else {
          this.setState({
            selectedBid: -1
          })
          this.props.onSetBids([])
          this.props.saveComplimentsNumber(new Array<ComplimentsNumber>())
        }
      })
      .catch(error => {
          if(!this._isMounted)
              return;
        console.log('Can not load bids', error.message)
        clearInterval(this.state.checkBidsInterval)
        this.setState({
          errorTitle: StringResources.getString(Strings.ViewBids.Errors.Messages.error),
          errorMessage: StringResources.getString(Strings.ViewBids.Errors.Messages.cannotLoadBids),
          isErrorDialogOpen: true
        })
      })
  }

  checkJobStatus = () => {
    Api.getJob(this.props.jobId)
      .then((result: any) => {
          if(!this._isMounted)
              return;
        this.props.onSetJobStatus(result.status)
        this.setState({
          status: result.status
        })
        if (result.status === JobStatus.ACCEPTED) {
          clearInterval(this.state.checkBidsInterval)
          this.setState({
            isJobAccepted: true,
            haulerId: result.haulerId
          })
          return true
        } else if (result.status === JobStatus.WAITING_FOR_PAYMENT_AUTHORIZATION) {
          this.props.setProviderId(result.haulerId)
          clearInterval(this.state.checkBidsInterval)
          this.props.routePush(ROUTES.WAITING_FOR_CARD_AUTHORIZATION)
        } else if (result.status === JobStatus.CREATED) {
          let hours = Math.floor(result.timeKeeping / 3600000)
          let minutes = Math.floor((result.timeKeeping - hours * 3600000) / 60000)
          let seconds = Math.floor((result.timeKeeping - minutes * 60000 - hours * 3600000) / 1000)
          let secondTimeKeeping = 0

          if (this.state.minutes !== minutes && this.state.seconds !== seconds) {
            this.setState({
              hours: hours,
              minutes: minutes,
              seconds: seconds
            })

            let publishedJobParams = {
              confirmed: this.props.publishedJobParams.confirmed,
              hours: hours,
              minutes: minutes,
              seconds: seconds,
              createDate: this.props.publishedJobParams.createDate,
              timeKeeping: result.timeKeeping,
              timeStopBidding: result.timeStopBidding,
              secondTimeKeeping: secondTimeKeeping,
              biddingActiveDate: this.props.publishedJobParams.biddingActiveDate
            }

            this.props.onPublishedJobParams(publishedJobParams)
          }
        } else if (result.status === JobStatus.BIDDING_ACTIVE || result.status === JobStatus.BIDS_AWAITING_ACCEPTANCE) {
          let biddingActiveDate = this.props.publishedJobParams.biddingActiveDate === 0 ? moment.utc().valueOf() : this.props.publishedJobParams.biddingActiveDate
          let timeLeft = biddingActiveDate + result.timeKeeping - moment.utc().valueOf()
          let hours = Math.floor(result.timeKeeping / 3600000)
          let minutes = Math.floor((result.timeKeeping - hours * 3600000) / 60000)
          let seconds = Math.floor((timeLeft - minutes * 60000 - hours * 3600000) / 1000)

          this.setState({
            hours: hours,
            minutes: minutes,
            seconds: seconds
          })

          let publishedJobParams = {
            confirmed: this.props.publishedJobParams.confirmed,
            hours: this.props.publishedJobParams.hours,
            minutes: this.props.publishedJobParams.minutes,
            seconds: this.props.publishedJobParams.seconds,
            createDate: this.props.publishedJobParams.createDate,
            timeKeeping: this.props.publishedJobParams.timeKeeping,
            timeStopBidding: result.timeStopBidding,
            secondTimeKeeping: result.timeKeeping,
            biddingActiveDate: biddingActiveDate
          }
          this.props.onPublishedJobParams(publishedJobParams)

        } else if (result.status === JobStatus.CANCELLED_BY_HAULER || result.status === JobStatus.DECLINED_AUTO
          || result.status === JobStatus.DECLINED_BY_HAULER) {
          clearInterval(this.state.checkBidsInterval)
          this.props.onRemoveJobDetails()
          this.props.removeJob()
          this.setState({
            isErrorDialogOpen: true,
            errorTitle: StringResources.getString(Strings.ViewBids.Errors.Messages.jobCancelled)
          })
        } else if (result.status === JobStatus.CANCELLED_BY_CUSTOMER || result.status === JobStatus.DECLINED_BY_CUSTOMER) {
          clearInterval(this.state.checkBidsInterval)
          this.props.onRemoveJobDetails()
          this.props.removeJob()
          this.setState({
            isErrorDialogOpen: true,
            errorTitle: StringResources.getString(Strings.ViewBids.Errors.Messages.jobCancelled)
          })
        } else if (this.state.timeExpired) {
          this.props.onRemoveJobDetails()
          this.props.removeJob()
          clearInterval(this.state.checkBidsInterval)
          console.log('interval cleared')
        }
        return false
      })
      .then(result => {
        if (result) {
          clearInterval(this.state.checkBidsInterval)
          this.props.setProviderId(this.state.haulerId)
          this.props.routePush(ROUTES.BID_ACCEPTED)
        }
      })
      .catch(error => {
          if(!this._isMounted)
              return;
        Api.logError({
          component: 'ViewBids',
          method: 'checkJobStatus',
          error: prepareError(error)
        });

        console.log('Can not load job status.', error)
        clearInterval(this.state.checkBidsInterval)
        this.setState({
          errorTitle: StringResources.getString(Strings.ViewBids.Errors.Messages.error),
          errorMessage: StringResources.getString(Strings.ViewBids.Errors.Messages.jobStatusError),
          isErrorDialogOpen: true
        })
      })
  }

  setComplimentsNumber = (complimentsArray, bids) => {
    let complimentsNumber: ComplimentsNumber[]
    if (complimentsArray === null) {
      complimentsNumber = bids.map(bid => {
        let tempNumber = bid.hauler && bid.hauler.numberCompliments ? { number: `${bid.hauler.numberCompliments}`, haulerId: bid.haulerId }
          : { number: `${Math.floor(Math.random() * Math.floor(3)) + 2}`, haulerId: bid.haulerId }
        return tempNumber
      })
      this.props.saveComplimentsNumber(complimentsNumber)
    } else {
      complimentsNumber = bids.map(bid => {
        if (complimentsArray.find(item => item.haulerId === bid.haulerId) === undefined) {
          let tempNumber = bid.hauler && bid.hauler.numberCompliments ? { number: `${bid.hauler.numberCompliments}`, haulerId: bid.haulerId }
            : { number: `${Math.floor(Math.random() * Math.floor(3)) + 2}`, haulerId: bid.haulerId }
          return tempNumber
        } else {
          let index = this.props.complimentsNumber.findIndex(item => item.haulerId === bid.haulerId)
          return this.props.complimentsNumber[index]
        }
      })
      this.props.saveComplimentsNumber(complimentsNumber)
      this.setState({ complimentsNumber: complimentsNumber })
    }
    return complimentsNumber
  }

  selectBid = (event: any) => {

    this.setState({
      selectedBid: event.currentTarget.value,
      haulerId: this.state.bidsArray[event.currentTarget.value].haulerId
    })
  }
  selectSpecifiedBid = (index) => () => {
    this.setState({
      selectedBid: index,
      haulerId: this.state.bidsArray[index].haulerId
    })
  }

  checkBids = () => {
    let countable = this.props.jobCategories[this.props.selectedJobCategory].countable
    let checkBidsInterval = setInterval(() =>
      countable ? this.checkJobStatus() : this.loadAndSaveBids(),
      interval)
    this.setState({
      checkBidsInterval: checkBidsInterval
    })
  }

  componentWillUnmount() {
      this._isMounted = false;
    clearInterval(this.state.checkBidsInterval)
  }

  handleCancel = () => {
    clearInterval(this.state.checkBidsInterval)
    this.handleDialogClose()

    Api.getJob(this.state.jobId)
      .then((job: any) => {
          if(!this._isMounted)
              return;
        this.setState({
          status: job.status
        })
        return job.status
      })
      .then(status => {
        if (status === JobStatus.CREATED || status === JobStatus.UNDER_REVIEW || JobStatus.BIDDING_ACTIVE || JobStatus.BIDS_AWAITING_ACCEPTANCE) {
          Api.changeStatus(this.state.jobId, JobStatus.CANCELLED_BY_CUSTOMER)
            .then(() => this.props.routePush(ROUTES.PICKUP_LOCATION))
            .catch(error => {
              console.log('can not change job status', error)
              this.props.onErrorEvent(Mapper.mapError(error))
            })
        } else {
          if (status === JobStatus.ACCEPTED || status === JobStatus.HAULER_ARRIVING
            || status === JobStatus.CONFIRM_ARRIVAL || status === JobStatus.WAITING_FOR_PAYMENT_AUTHORIZATION) {
            Api.changeStatus(this.state.jobId, JobStatus.DECLINED_BY_CUSTOMER)
              .then(() => this.props.routePush(ROUTES.PICKUP_LOCATION))
              .catch(error => {
                console.log('can not change job status', error)
                this.props.onErrorEvent(Mapper.mapError(error))
              })
          }
        }

        this.props.onRemoveJobDetails()
        this.props.removeJob()
      })
  }

  acceptBid = () => {
    let amount = this.state.bidsArray[this.state.selectedBid].bid
    this.setState({
      isAcceptDialogOpen: false
    })
    clearInterval(this.state.checkBidsInterval)
    console.log('interval cleared')
    this.props.setProviderId(this.state.haulerId)
    this.props.onSetAmount(amount)

    this.props.routePush(ROUTES.WAITING_FOR_CARD_AUTHORIZATION)
  }

  handleDialogOpen = () => {
    this.setState({
      isDialogOpen: true
    })
  }

  handleDialogClose = () => {
    this.setState({
      isDialogOpen: false
    })
  }

  handleAcceptDialogOpen = () => {
    this.setState({
      isAcceptDialogOpen: true
    })
  }

  handleAcceptDialogClose = () => {
    this.setState({
      isAcceptDialogOpen: false
    })
  }

  handleTimeExpired = () => {
    clearInterval(this.state.checkBidsInterval)
    this.props.onRemoveJobDetails()
    this.props.removeJob()
    this.setState({
      isErrorDialogOpen: true,
      errorTitle: StringResources.getString(Strings.ViewBids.Errors.Messages.jobTimeOut)
    })
  }

  handleErrorDialogClose = (e: any) => {
    this.props.onRemoveJobDetails()
    this.props.removeJob()
    this.setState({
      isErrorDialogOpen: false
    })
    if (e.currentTarget.name === this.state.errorTitle) {
      this.props.routePush(ROUTES.PICKUP_LOCATION)
    }
  }

  getComplimentsNumber = (haulerId) => {
    let complimentNumber: ComplimentsNumber = this.state.complimentsNumber.find(item => item.haulerId === haulerId)!
    return complimentNumber ? complimentNumber.number : ''
  }

  setTimerValue = (value: string, isBiddingExpiring: boolean) => {
    this.setState({
      timerValue: value,
      isBiddingExpiring: isBiddingExpiring
    })
  }

  getTime = (time: Slots) => {
    let timeFrom = moment(time.dateFrom).hour() > 12 ? moment(time.dateFrom).hour() - 12 : moment(time.dateFrom).hour()
    let timeTo = moment(time.dateTo).hour() > 12 ? moment(time.dateTo).hour() - 12 : moment(time.dateTo).hour()
    let amPm = moment(time.dateTo).hour() > 12 ? 'pm' : 'am'
    return `${timeFrom} - ${timeTo} ${amPm}`
  }

  render() {
    let bidsTemplate = this.state.complimentsNumber !== null ? this.state.bidsArray.map((item, index) => {
      if (index < 5) {
        return (
          <li key={index} value={index} onClick={this.selectBid}>
            <ListItem
              value={index}
              className={index === this.state.selectedBid ? 'bids-list-item-selected' : 'bids-list-item'}
              leftAvatar={<div className="hauler-avatar" ><img src={item.hauler ? item.hauler.avatar : images.avatar2} /></div>}
              rightAvatar={
                <div className="bid-text">
                  {index === 0 ? <img className={'bid-choice'} src={images.choice} /> : null}
                  <span className={'bid-price'}>${item.bid && getFormatedPrice(item.bid)}</span>
                  {
                    this.state.bidsArray.length === 1 ?
                        null :
                        <div className={'hover'}>
                          <FlatButton
                              label={StringResources.getString(Strings.ViewBids.Buttons.Select.label)}
                              className="flatbutton next bid-accept"
                              onClick={this.selectSpecifiedBid(index)}
                          />
                        </div>
                  }
                </div>
              }
              primaryText={
                <div className="primary-text">
                  <ul>
                    <li>{`Provider - ${item.haulerId ? Hash.dummyHashCode(item.haulerId) : index}`}</li>
                    <li><b>{moment(item.timeSlot.dateFrom).format('MMMM D: ')}</b>{this.getTime(item.timeSlot)}</li>
                  </ul>
                </div>
              }
              secondaryText={
                <div className="secondary-text">
                  <span>
                    {`${StringResources.getString(Strings.ViewBids.Text.complimentsReceived)} ${item.hauler && this.getComplimentsNumber(item.haulerId)}`} <br />
                    <StarRatings
                      initialRating={item.hauler ? (item.hauler.rating ? Number(item.hauler.rating.toFixed(2)) : 0) : 0}
                      readonly={true}
                      className="-small"
                    />
                  </span>
                </div>
              }
              secondaryTextLines={2}
            />
            {
              index !== this.state.bidsArray.length - 1 ?
                <Divider className="divider" /> : null
            }
          </li>
        )
      }
    }) : null

    let countable = this.props.jobCategories.length !== 0 && this.props.selectedJobCategory && this.props.jobCategories[this.props.selectedJobCategory].countable

    return (
      <BaseContainer pageName={EventType.VIEW_BIDS} classname="view-bids viewBidsContainer">
        <DialogBox
          isDialogOpen={this.state.isDialogOpen}
          handleCancel={this.handleCancel}
          handleDialogClose={this.handleDialogClose}
          status={this.state.status}
        />
        <AcceptDialog
          isAcceptDialogOpen={this.state.isAcceptDialogOpen}
          acceptBid={this.acceptBid}
          handleDialogClose={this.handleAcceptDialogClose}
        />
        <ErrorDialog
          handleErrorDialogClose={this.handleErrorDialogClose}
          isErrorDialogOpen={this.state.isErrorDialogOpen}
          errorTitle={this.state.errorTitle}
          errorMessage={this.state.errorMessage}
        />
        <AppBarContainer
          isIconButtonsShown={true}
          isMenuShown={true}
        />
        <PageTitle
          text={countable ? StringResources.getString(Strings.ViewBids.Titles.jobPublished) : StringResources.getString(Strings.ViewBids.Titles.biddingInProgress)}
        />
        {
          this.state.bidsArray.length !== 0 ?
            <div className={this.state.isBiddingExpiring ? 'timer-top expiring' : 'timer-top'} >
              {
                this.state.timerValue !== null &&
                (
                  !this.state.isBiddingExpiring ? `${StringResources.getString(Strings.Components.Timer.Items.Glass.Title)} ${this.state.timerValue}` :
                    `${StringResources.getString(Strings.Components.Timer.Items.Glass.timerExpiringText)} ${this.state.timerValue}`
                )
              }
            </div> : null
        }
        <PerfectScrollbar className="bids-scrollbar">
          <ul className="bidsList">
            {bidsTemplate}
            {
              this.state.isUnderReview ?
                <div>
                  <li>
                    <ListItem
                      className={'bids-list-item'}
                      leftAvatar={<div className="hauler-avatar" ><img src={images.avatar2} /></div>}
                      primaryText={<div className="primary-text">{StringResources.getString(Strings.ViewBids.Text.hauler)}</div>}
                      secondaryText={
                        <div className="secondary-text">
                          <span>
                            {StringResources.getString(Strings.ViewBids.Text.jobReview)} <br />
                          </span>
                        </div>
                      }
                      secondaryTextLines={2}
                    />
                    <Divider className="divider" />
                  </li>
                </div>
                : null
            }
          </ul>
        </PerfectScrollbar>
        <Timer
          jobCategoryName={this.props.jobCategoryName}
          hours={this.state.hours}
          minutes={this.state.minutes}
          seconds={this.state.seconds}
          isErrorDialogOpen={this.state.isErrorDialogOpen}
          isTimeExpired={this.state.timeExpired}
          publishedJobParams={this.props.publishedJobParams}
          handleTimeExpired={this.handleTimeExpired}
          isThereBid={this.state.bidsArray.length !== 0}
          getTimerValue={this.setTimerValue}
        />
        <StickyContainer className="sticky-footer" >
          <Sticky>
            {() => (
              this.state.bidsArray.length !== 0 ?
                <div className={'bottom-part hover'}>
                  <FlatButton
                    label={StringResources.getString(Strings.ViewBids.Buttons.Cancel.label)}
                    className="flatbutton next"
                    onClick={this.handleDialogOpen}
                  />
                  {
                    this.state.selectedBid === -1 ?
                        <FlatButton
                            label={StringResources.getString(Strings.ViewBids.Buttons.Accept.label)}
                            className="flatbutton next disabled"
                            disabled={true}
                        /> :
                        <FlatButton
                            label={StringResources.getString(Strings.ViewBids.Buttons.Accept.label)}
                            className="flatbutton next"
                            onClick={this.handleAcceptDialogOpen}
                        />
                  }
                </div>
                :
                <div className={'bottom-part hover'}>
                  <FlatButton
                    label={StringResources.getString(Strings.ViewBids.Buttons.Cancel.label)}
                    className="flatbutton next"
                    onClick={this.handleDialogOpen}
                  />
                </div>
            )}
          </Sticky>
        </StickyContainer>
      </BaseContainer>
    )
  }
}

function mapStateToProps(state: StoreState) {
  return {
    routing: state.routing,
    jobId: state.jobDetails.jobId,
    publishedJobParams: state.publishedJobParams,
    jobCategoryName: state.jobDetails.jobCategoryName,
    selectedJobCategory: state.jobDetails.selectedJobCategory,
    jobCategories: state.jobDetails.jobCategories,
    complimentsNumber: state.jobDetails.complimentsNumber
  }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    routePush: (location: string) => dispatch(routerActions.push(location)),
    onErrorEvent: (errorInfo: ErrorInfo) => dispatch(ErrorActions.newError(errorInfo)),
    onSetJobStatus: (status: string) => dispatch(setJobStatus(status)),
    setProviderId: (providerId: string) => dispatch(setProviderId(providerId)),
    onRemoveJobDetails: () => dispatch(removeJobDetails()),
    removeJob: () => dispatch(JobActions.createJob(null)),
    onSetAmount: (amount: number) => dispatch(setAmount(amount)),
    onPublishedJobParams: (publishedJobParams: PublishedJobParams) => dispatch(setPublishedJobParams(publishedJobParams)),
    saveComplimentsNumber: (complimentsNumber: ComplimentsNumber[]) => dispatch(saveComplimentsNumber(complimentsNumber)),
    onSetFutureDateFrom: (futureDateFrom: number) => dispatch(setFutureDateFrom(futureDateFrom)),
    onSetFutureDateTo: (futureDateTo: number) => dispatch(setFutureDateTo(futureDateTo)),
    onSetBids: (bids: Bid[]) => dispatch(setBids(bids))
  }
}

export const ViewBidsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewBids)



// WEBPACK FOOTER //
// ./src/containers/ViewBids.tsx